/* French / English translations for the public site. */
export const dict = {
  fr: {
    nav: {
      home: "Accueil",
      sejourner: "Séjourner",
      celebrer: "Célébrer",
      reunir: "Se réunir",
      haras: "Le Haras",
      evenements: "Événements",
      decouvrir: "Découvrir la Maison",
      contact: "Contact",
      admin: "Extranet",
    },
    common: {
      request_brochure: "Demander la brochure",
      request_visit: "Demander une visite",
      check_availability: "Vérifier une disponibilité",
      contact_us: "Nous écrire",
      read_more: "En savoir plus",
      more: "Plus",
      loading: "Chargement…",
    },
    home: {
      eyebrow: "Maison d'hospitalité et de patrimoine",
      hero_title: "Domaine de la Briouse",
      hero_subtitle: "Une Maison au cœur de la Vienne, entre pierre, forêts et chevaux — pensée pour ceux qui aiment prendre le temps.",
      intro_eyebrow: "La Maison",
      intro_title: "Un lieu, plusieurs vies",
      intro_body: "À Sanxay, dans la Vienne, le Domaine de la Briouse rassemble depuis toujours des vies qui aiment se croiser : familles en villégiature, mariés, cavaliers, séminaires, associations, artistes. Nous transmettons un lieu, un savoir-faire, une attention.",
      universes_title: "Nos univers",
      universes_lead: "Six manières de vivre le Domaine, selon la saison, l'envie ou l'occasion.",
      housing_title: "Séjourner",
      housing_lead: "Chambres d'hôtes et gîtes, pour une nuit, un week-end, une saison.",
      weddings_title: "Célébrer",
      weddings_lead: "Un cadre patrimonial pour un mariage sincère et sur mesure.",
      haras_title: "Le Haras de la Briouse",
      haras_lead: "Pension, valorisation et éducation des chevaux, dans le respect de leur nature.",
      events_title: "Les événements",
      events_lead: "Concerts, randonnées, stages, rencontres — le rythme du Domaine au fil des saisons.",
      reunir_title: "Se réunir",
      reunir_lead: "Séminaires, retraites créatives, journées d'étude : des espaces qui invitent à penser autrement.",
      journal_title: "Journal BRIOUSE",
      journal_lead: "Récits de la Maison, portraits, saisons et coulisses.",
      contact_title: "Nous rencontrer",
      contact_lead: "Écrivez-nous, appelez-nous, ou venez frotter vos pas à la pierre. Nous vous répondrons avec attention.",
    },
    weddings: {
      eyebrow: "Célébrer au Domaine",
      title: "Un mariage à la Briouse",
      lead: "Une journée à votre image, dans un lieu qui n'appartient qu'à vous le temps d'un week-end.",
      spaces_title: "Nos espaces",
      spaces_lead: "Cour d'honneur, orangerie, granges, jardins d'agrément : plusieurs atmosphères pour un même récit.",
      housing_title: "Vos invités dorment sur place",
      housing_lead: "Chambres d'hôtes et gîtes vous permettent d'accueillir jusqu'à plusieurs dizaines d'invités à quelques pas de la fête.",
      advantages_title: "Les atouts du Domaine",
      advantage_1: "Un lieu privatisé, à vous seuls, pour un vrai week-end de mariage.",
      advantage_2: "Une équipe attentive, présente sans jamais s'imposer.",
      advantage_3: "Un cadre naturel préservé, sans standardisation touristique.",
      advantage_4: "Des solutions d'hébergement sur place pour vos proches.",
      faq_title: "Questions fréquentes",
      faq_1_q: "Quelle capacité peut accueillir le Domaine ?",
      faq_1_a: "Selon la configuration retenue, jusqu'à 200 invités pour la réception, avec des espaces intérieurs et extérieurs modulables.",
      faq_2_q: "Peut-on privatiser l'ensemble du Domaine ?",
      faq_2_a: "Oui, la privatisation complète est possible pour un week-end entier, du vendredi au dimanche.",
      faq_3_q: "Proposez-vous des prestataires recommandés ?",
      faq_3_a: "Nous partageons volontiers notre carnet d'adresses : traiteurs, fleuristes, photographes, musiciens — tous choisis pour la qualité de leur travail.",
      cta_title: "Envie d'en parler ?",
      cta_lead: "Ces premiers échanges sont importants. Écrivez-nous et nous vous rappelons.",
    },
    footer: {
      about: "Le Domaine",
      about_body: "Une Maison familiale d'hospitalité et de patrimoine, à Sanxay (Vienne).",
      contact: "Nous contacter",
      address: "Le Domaine de la Briouse, 86600 Sanxay, France",
      legal: "Mentions légales",
      privacy: "Confidentialité",
      copyright: "© {year} Domaine de la Briouse — Tous droits réservés",
      language: "Langue",
    },
    notfound: {
      title: "Cette page s'est perdue en chemin",
      lead: "Le lien que vous avez suivi n'existe pas ou plus. Revenez vers la Maison — nous vous y attendons.",
      back: "Retour à l'accueil",
    },
    admin: {
      title: "Extranet Briouse",
      subtitle: "Espace de travail des collaborateurs",
      sign_in_google: "Se connecter avec Google",
      sign_in_hint: "L'accès est réservé aux collaborateurs autorisés.",
    },
  },
  en: {
    nav: {
      home: "Home",
      sejourner: "Stay",
      celebrer: "Celebrate",
      reunir: "Gather",
      haras: "The Stud Farm",
      evenements: "Events",
      decouvrir: "About the House",
      contact: "Contact",
      admin: "Extranet",
    },
    common: {
      request_brochure: "Request the brochure",
      request_visit: "Request a visit",
      check_availability: "Check availability",
      contact_us: "Write to us",
      read_more: "Read more",
      more: "More",
      loading: "Loading…",
    },
    home: {
      eyebrow: "House of hospitality and heritage",
      hero_title: "Domaine de la Briouse",
      hero_subtitle: "A House at the heart of the Vienne — between stone, forests and horses. For those who love to take their time.",
      intro_eyebrow: "The House",
      intro_title: "One place, many lives",
      intro_body: "In Sanxay, deep in the Vienne, the Domaine de la Briouse has always been where lives cross paths: families on holiday, newlyweds, riders, seminars, associations, artists. We pass on a place, a craft, a quiet attention.",
      universes_title: "Our worlds",
      universes_lead: "Six ways to experience the Domaine, depending on the season, the mood, the occasion.",
      housing_title: "Stay",
      housing_lead: "Guest rooms and cottages, for a night, a weekend, a season.",
      weddings_title: "Celebrate",
      weddings_lead: "A heritage setting for a sincere, tailor-made wedding.",
      haras_title: "The Briouse Stud Farm",
      haras_lead: "Boarding, training and education of horses, respectful of their nature.",
      events_title: "Events",
      events_lead: "Concerts, rides, workshops, gatherings — the rhythm of the Domaine, season by season.",
      reunir_title: "Gather",
      reunir_lead: "Seminars, creative retreats, study days: spaces that invite you to think differently.",
      journal_title: "BRIOUSE Journal",
      journal_lead: "Stories from the House, portraits, seasons and behind-the-scenes.",
      contact_title: "Come and meet us",
      contact_lead: "Write, call, or come and let your steps meet our stones. We will answer with care.",
    },
    weddings: {
      eyebrow: "Celebrate at the Domaine",
      title: "A wedding at Briouse",
      lead: "A day of your own, in a place that is yours alone for the length of a weekend.",
      spaces_title: "Our spaces",
      spaces_lead: "Courtyard of honour, orangery, barns, ornamental gardens: several atmospheres for one story.",
      housing_title: "Your guests sleep on site",
      housing_lead: "Guest rooms and cottages let you welcome dozens of guests just steps away from the celebration.",
      advantages_title: "Why choose the Domaine",
      advantage_1: "A place privatised for you alone, for a true wedding weekend.",
      advantage_2: "An attentive team, present without ever intruding.",
      advantage_3: "A preserved, natural setting — never standardised, never touristy.",
      advantage_4: "On-site accommodation solutions for your loved ones.",
      faq_title: "Frequently asked",
      faq_1_q: "What capacity can the Domaine host?",
      faq_1_a: "Depending on the configuration, up to 200 guests for the reception, with modular indoor and outdoor spaces.",
      faq_2_q: "Can the whole Domaine be privatised?",
      faq_2_a: "Yes — full privatisation is available for the entire weekend, from Friday to Sunday.",
      faq_3_q: "Do you recommend trusted suppliers?",
      faq_3_a: "We happily share our address book: caterers, florists, photographers, musicians — all chosen for the quality of their work.",
      cta_title: "Shall we talk?",
      cta_lead: "These first exchanges matter. Write to us and we will call you back.",
    },
    footer: {
      about: "The Domaine",
      about_body: "A family House of hospitality and heritage, in Sanxay (Vienne).",
      contact: "Contact us",
      address: "Le Domaine de la Briouse, 86600 Sanxay, France",
      legal: "Legal notice",
      privacy: "Privacy",
      copyright: "© {year} Domaine de la Briouse — All rights reserved",
      language: "Language",
    },
    notfound: {
      title: "This page has lost its way",
      lead: "The link you followed no longer exists. Come back to the House — we are waiting for you.",
      back: "Back to home",
    },
    admin: {
      title: "Briouse Extranet",
      subtitle: "Collaborators' workspace",
      sign_in_google: "Sign in with Google",
      sign_in_hint: "Access is reserved for authorised collaborators.",
    },
  },
};
